import React, { useState, useContext } from "react";
import { QuizContext } from "../../../assets/context/index";
import "./styled.css";

const questions = [
  {
    option: "a) Interface intuitiva",
    correct: false,
  },
  {
    option: "b) Foco em resultados de negócio",
    correct: false,
  },
  {
    option: "c) Implantação de projetos com payback curto",
    correct: false,
  },
  {
    option: "d) Atuação também no controle regulatório",
    correct: false,
  },
  {
    option: "e) Telas customizáveis para cada cliente",
    correct: true,
  },
];

export default function Question20(props) {
  const { t } = useContext(QuizContext);
  const { setQuestionSelected, checkAnswers } = props;
  const [optionSelected, setOptionSelected] = useState("");

  function selectOption(option) {
    setOptionSelected(option.option);

    setQuestionSelected((state) => {
      return {
        ...state,
        question20: {
          title:
            "Qual das características não é um diferencial do SAI Smart Process?",
          option: option.option,
          correct: option.correct,
          order: 20
        },
      };
    });
  }
  return (
    <div style={{ marginTop: 30 }}>
      <h5 style={{ textAlign: "center" }}>
        {t(
          "Qual das características não é um diferencial do SAI Smart Process?"
        )}
      </h5>

      <div className="div-options-question-ste">
        {questions.map((e, i) => (
          <a
            key={i}
            className={`option-question-ste ${
              optionSelected === e.option && "selected-option-question-ste"
            } ${checkAnswers && (e.correct ? "check-true" : "check-false")}`}
            onClick={() => {
              if (!checkAnswers) {
                selectOption(e);
              }
            }}
          >
            {t(e.option)}
          </a>
        ))}
      </div>
    </div>
  );
}
